import { UserPermissions } from "./permissions";

// API response interfaces (matching backend models)
export interface RoleOut {
  id: number;
  name: string;
}

export interface RoleCreate {
  name: string;
}

export interface UserOut {
  entra_oid: string;
  role_id: number;
  role: string; // Changed to string as per backend UserOut model
  name: string;
  username: string;
  email: string;
  permissions: UserPermissions;
}

export interface UserCreate {
  entra_oid: string;
  role_id: number;
}

export interface UserUpdate {
  role_id?: number;
}

// Azure Graph API interfaces
export interface AzureUser {
  id: string;
  name: string;
  email: string;
  username: string;
}

export interface ConsentRequiredError {
  error: "consent_required";
  message: string;
  consent_url: string;
  details: string;
}

// Response types for API endpoints
export type SearchAzureUsersResponse = AzureUser[] | ConsentRequiredError;

// Helper function to check if response is a consent error
export function isConsentRequiredError(
  response: SearchAzureUsersResponse,
): response is ConsentRequiredError {
  return typeof response === "object" && !Array.isArray(response) && "error" in response;
}

// Frontend interfaces (for compatibility with existing components)
export interface User {
  id: string;
  name: string;
  email: string;
  role: string; // Role name as string
  permissions: UserPermissions;
}

// Interface for users available to be added (matches AzureUser from search)
export interface AvailableUser {
  id: string;
  name: string;
  email: string;
  username: string;
}
